/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';

import { useDebounce } from '../../shared/hooks';
import { ParceirosService } from '../services/api/cadastros/ParceirosService';

type TAutoCompleteOption = {
  idparceiro: string;
  label: string;
}

interface IAutoCompleteParceiroProps {
  isExternalLoading?: boolean;
  uuidparceiro?: (novoTextoselect: string | undefined) => void;
  nome?: (novoTextoselect: string | undefined) => void;
  // Pré-seleciona um parceiro já conhecido (ex.: filtro salvo na URL da
  // listagem, ou voltando de uma tela de detalhe) sem precisar buscar/
  // selecionar de novo — sem isso o campo sempre inicia em branco, mesmo que
  // a listagem já esteja filtrada por esse parceiro (ver ListagemContasReceber.tsx).
  valorInicial?: { idparceiro: string; nome: string } | null;
}

export const AutoCompleteParceiroListagem: React.FC<IAutoCompleteParceiroProps> = ({ isExternalLoading = false, uuidparceiro, nome, valorInicial}) => {

  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>(valorInicial?.idparceiro || '');

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>(
    valorInicial?.idparceiro ? [{ idparceiro: valorInicial.idparceiro, label: valorInicial.nome }] : []
  );
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    if (!valorInicial?.idparceiro) return;
    setSelectedId(valorInicial.idparceiro);
    setOpcoes((atual) => atual.some((opcao) => opcao.idparceiro === valorInicial.idparceiro)
      ? atual
      : [{ idparceiro: valorInicial.idparceiro, label: valorInicial.nome }, ...atual]);
  }, [valorInicial?.idparceiro, valorInicial?.nome]);

  useEffect(() => {
    setIsLoading(true);
  
    debounce(() => {
      ParceirosService.getAllList(busca, selectedId)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(parceiro => ({ idparceiro: parceiro.idparceiro, label: parceiro.nome + ' - ' + parceiro.cpf })));
          }
        });
    });
  }, [busca, selectedId]);
 
  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idparceiro === selectedId); 
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);
   
  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'
      disablePortal
      size='small'
      fullWidth
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      // Só busca sozinho por `reason==='input'` — ver AutoCompleteMunicipio.tsx pro caso
      // completo do loop que isso evita (reset automático do MUI virando busca).
      onInputChange={(_, newValue, reason) => {
        if (reason === 'input') setBusca(newValue);
      }}
      onChange={(_, newValue) => { setSelectedId(newValue?.idparceiro); nome?.(newValue?.label); uuidparceiro?.(newValue?.idparceiro);  setBusca('');  }}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}

          label="Parceiros"
          // error={!!error}  
          // helperText={error}
        />
      )}
    />
  );
};